import React from "react";
import { ModuleConfig } from "../../types/ModuleConfig";

// Import admin components (lazy-loaded for performance)
const AdminDashboard = React.lazy(() => import("../AdminDashboard"));
const TenantsList = React.lazy(() => import("./TenantsList"));
const CreateTenant = React.lazy(() => import("./CreateTenant"));
const EditTenant = React.lazy(() => import("./EditTenant"));
const DeploymentManager = React.lazy(() => import("./DeploymentManager"));
const TenantDeploymentManager = React.lazy(() => import("./TenantDeploymentManager"));
const BillChaserPage = React.lazy(() => import("./billChaserPage"));

const adminModuleConfig: ModuleConfig = {
    // 🏷️ MODULE IDENTITY
    id: "admin",
    name: "Admin Dashboard",
    description: "Administrative tools and management interface",
    version: "0.0.1",
    enabled: true,
    category: "administration",
    order: 100, // High order to appear at the end
    icon: "⚙️",
    color: "#718096",

    // 🛣️ ROUTES
    routes: [
        {
            path: "/admin",
            component: AdminDashboard,
            permissions: ["ADMIN", "WEBSITE_MASTER"]
        },
        {
            path: "/admin/tenants",
            component: TenantsList,
            permissions: ["ADMIN", "WEBSITE_MASTER"]
        },
        {
            path: "/admin/tenants/new",
            component: CreateTenant,
            permissions: ["ADMIN", "WEBSITE_MASTER"]
        },
        {
            path: "/admin/tenants/:id/edit",
            component: EditTenant,
            permissions: ["ADMIN", "WEBSITE_MASTER"]
        },
        {
            path: "/admin/deploy",
            component: DeploymentManager,
            permissions: ["ADMIN", "WEBSITE_MASTER"]
        },
        {
            path: "/admin/tenant-deployment",
            component: TenantDeploymentManager,
            permissions: ["ADMIN", "WEBSITE_MASTER"]
        },
        {
            path: "/bill-chaser",
            component: BillChaserPage,
            permissions: ["ADMIN"]
        }
    ],

    // 🧭 NAVIGATION
    navigation: [
        {
            label: "Admin Dashboard",
            path: "/admin",
            icon: "📊",
            permissions: ["ADMIN", "WEBSITE_MASTER"]
        },
        {
            label: "Tenant Management",
            path: "/admin/tenants",
            icon: "🏢",
            permissions: ["ADMIN", "WEBSITE_MASTER"]
        },
        {
            label: "Create Tenant",
            path: "/admin/tenants/new",
            icon: "➕",
            permissions: ["ADMIN", "WEBSITE_MASTER"]
        },
        {
            label: "Deployment Manager",
            path: "/admin/deploy",
            icon: "🚀",
            permissions: ["ADMIN", "WEBSITE_MASTER"]
        },
        {
            label: "Module Deployment",
            path: "/admin/tenant-deployment",
            icon: "📦",
            permissions: ["ADMIN", "WEBSITE_MASTER"]
        },
        {
            label: "Bill Chaser",
            path: "/bill-chaser",
            icon: "💸",
            permissions: ["ADMIN"]
        }
    ],

    // 🔐 PERMISSIONS - Highly restrictive for admin tools
    permissions: {
        view: ["ADMIN", "WEBSITE_MASTER"],
        create: ["ADMIN", "WEBSITE_MASTER"],
        edit: ["ADMIN", "WEBSITE_MASTER"],
        delete: ["ADMIN", "WEBSITE_MASTER"]
    },

    // ⚡ QUICK ACTIONS
    quickActions: [
        {
            label: "Create Tenant",
            path: "/admin/tenants/new",
            icon: "🏢",
            description: "Add a new tenant to the system"
        },
        {
            label: "Deploy Modules",
            path: "/admin/tenant-deployment",
            icon: "🚀",
            description: "Deploy modules to tenant sites"
        }
    ]
};

export default adminModuleConfig;